import documents from '../../../public/documents-juridiques/2026-10-29.json';

export const legalDocuments = documents;
export const LEGAL_DOCUMENT_VERSION = documents.version;
export const legalAcceptanceMessage = "Veuillez accepter les conditions générales d’utilisation et prendre connaissance de la politique de confidentialité.";
